'use client'
import { PrismicRichText } from "@prismicio/react";
import { useEffect, useRef, useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.TestimonialConceptSlice} TestimonialConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TestimonialConceptSlice>} TestimonialConceptProps
 * @param {TestimonialConceptProps}
 */

const TestimonialConceptItem = ({ testimonial, i, selected }) => {
  const $ref = useRef()

  useEffect(() => {
    const targetScroll = $ref.current.offsetLeft * selected;
    $ref.current.parentElement.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  });


  return <div ref={$ref} className={`snap-center snap-always lg:mx-0 carousel-item w-[298px] w-calc-testimonial xl:w-[373px] flex flex-col justify-between rounded-30px p-7 
  ${i % 2 == 0 ? 'bg-pink' : 'bg-green'}`}>
    <div className="">
      <div className="small">
        <PrismicRichText field={testimonial.text} />
      </div>

      <div className="text-info pt-6">
        <PrismicRichText field={testimonial.name} />
      </div>
    </div>
  </div>

}
const TestimonialConcept = ({ slice, index }) => {

  const [selected, setSelected] = useState(0);

  function prev() {
    if (selected <= 0) {
      setSelected(0)
    } else {
      setSelected(selected - 3)
    }
  }

  function next() {
    if (selected >= slice.primary.testimonials.length - 1) {
      setSelected(slice.primary.testimonials.length - 1)
    } else {
      setSelected(selected + 3)
    }
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white bg-grain ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="pt-10 pb-12 md:py-20 lg:pb-12">
        <div className="h2-like md:text-center px-4 md:px-7">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className="md:text-center mb-8 md:mb-16 px-4 md:px-7">
          <PrismicRichText field={slice.primary.text} />
        </div>

        <div>
          <div className="w-full flex gap-4 md:gap-7 snap-x snap-mandatory overflow-x-auto no-scrollbar lg:hidden px-4 md:px-7 lg:px-0">
            {
              slice.primary.testimonials.map((testimonial, i) => {
                return <TestimonialConceptItem key={i} testimonial={testimonial} i={i} />
              })
            }
          </div>
        </div>

        <div className="hidden lg:block">
          <div className="carousel flex justify-center align-center">
            <div className="carousel-track flex  mx-10 max-w-[1200px] gap-x-10">
              {
                slice.primary.testimonials.map((testimonial, i) => {
                  return <TestimonialConceptItem key={i} testimonial={testimonial} i={i} selected={selected} />
                })
              }
            </div>
          </div>
          {
            slice.primary.testimonials.length <= 3 && <div className="py-8"></div>
          }
          {
            slice.primary.testimonials.length > 3 && <div className="hidden md:block">
              <div className="flex flex-row justify-center py-10">
                <div className={`mx-2.5 arrow-left cursor-pointer ${selected === 0 ? 'opacity-10' : 'opacity-100'}`} onClick={prev}>
                  <img src="svg/arrow-left.svg" loading="lazy"/>
                </div>
                <div className={`mx-2.5 arrow-right cursor-pointer ${selected < slice.primary.testimonials.length - 1 ? 'opacity-100' : 'opacity-20'}`} onClick={next}>
                  <img src="svg/arrow-right.svg" loading="lazy"/>
                </div>
              </div>

              <div className="flex flex-row justify-center">
                {slice.primary.testimonials.map((_, i, arr) => {
                  {
                    if (i < Math.ceil(arr.length / 3)) {
                      return <span key={i} className={`dot  mx-2 ${i === selected / 3 ? " active" : ""}`}></span>
                    }
                  }
                })}
              </div>
            </div>
          }

        </div>
      </div>
    </section>
  );
};

export default TestimonialConcept;
